import $ from 'jquery';

export default function( target ) {

    let isEmpty = false;
		
	target.each(function(idx, select){

		if( ! $(this).val() ) {
	   		isEmpty = true;
    		return false;
  		}

	});

	return isEmpty;

}